import React from "react";
import ImageMobile from "../../assets/images/Mobile.svg";
import LogoKuopio from "../../assets/images/kuopio_logo.png";
import ListItem from "../../components/list-item/list-item";
import Sidebar, { SidebarButton } from "../../components/sidebar/sidebar";
import { useIsMobile } from "../../hooks/useIsMobile";
import Elements from "../../utils/getElements";
import "./page-start.scss";

const PageHome = () => {
  const isMobile = useIsMobile({ width: 960 });

  const mobileView = (
    <div className="page">
      <div className="pageStart--content">
        <img
          aria-hidden="true"
          alt=""
          src={LogoKuopio}
          className="kuopioLogo"
        />
        <h1 style={{ marginBottom: 24 }}>
          Hyvinvointi&shy;suunnitelma 2026-2030
        </h1>
        <h2 style={{ marginBottom: 34 }}>
          Matkalla hyvän elämän pääkaupungiksi
        </h2>
        <div>{list}</div>

        <h4 className="pageStart--description">
          Kuopion hyvinvointisuunnitelma linjaa toimintaa kuopiolaisten
          hyvinvoinnin ja terveyden edistämiseksi. Sen avulla ohjataan ja
          kehitetään hyvinvoinnin edistämistyötä koko Kuopiossa. Suunnitelman
          pohjana on viisi hyvinvoinnin osa-aluetta, niin sanottua hyvän elämän
          elementtiä, joiden alla on lukuisia tavoitteita ja
          toimenpidekokonaisuuksia.
          <br />
          <br />
          Kuopion hyvinvointisuunnitelmaan on sisällytetty myös seuraavat
          hyvinvoinnin edistämisen lakisääteiset suunnitelmat: lasten ja nuorten
          hyvinvointisuunnitelma, ikääntyneiden hyvinvointisuunnitelma, sekä
          ehkäisevän päihdetyön suunnitelma. Kuopion hyvinvointisuunnitelma
          pitää sisällään myös arjen turvallisuutta käsitteleviä osioita. Tällä
          sivustolla on esitetty hyvinvointisuunnitelman elementit, tavoitteet
          ja toimenpidekokonaisuudet. Tutustumalla koko suunnitelmaan, saat
          kattavan kuvan koko suunnitelmaa koskevista periaatteista,
          tahtotilasta ja tekemisestä kuopiolaisten hyvinvoinnin edistämiseksi.
        </h4>
      </div>

      <div className="mobileElements">
        {Elements.map((item, index) => (
          <SidebarButton
            key={item.title}
            item={item}
            number={index + 1}
            circleSize={"large"}
          />
        ))}
      </div>

      <img
        alt=""
        aria-hidden="true"
        src={ImageMobile}
        style={{
          padding: 40,
          paddingBottom: 12,
          maxHeight: 700,
          maxWidth: "100%",
          boxSizing: "border-box",
        }}
      />

      <a
        href="https://www.kuopio.fi/app/uploads/2026/05/kuopion-hyvinvointisuunnitelma-2026-2030-valmis.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="frontPageLink"
        style={{
          textAlign: "center",
          padding: 40,
          paddingBottom: 20,
        }}
      >
        Katso koko hyvinvointisuunnitelma
      </a>
      <a
        href="https://www.kuopio.fi/vapaa-aika-ja-hyvinvointi/hyvinvoiva-kuopio/"
        target="_blank"
        rel="noopener noreferrer"
        className="frontPageLink"
        style={{
          textAlign: "center",
          padding: 40,
          paddingTop: 20,
        }}
      >
        Hyvinvoiva Kuopio
      </a>
    </div>
  );

  if (isMobile) return mobileView;

  return (
    <div className="page">
      <Sidebar items={Elements} showMainItems={false} />

      <div className="pageStart--content">
        <div className="pageStart--content--inner">
          <img
            aria-hidden="true"
            alt=""
            src={LogoKuopio}
            className="kuopioLogo"
          />
          <h1 style={{ marginBottom: 24, marginTop: 28, paddingRight: 120 }}>
            Hyvinvointi&shy;suunnitelma
            <br />
            2026-2030
          </h1>
          <h2 style={{ marginBottom: 44 }}>
            Matkalla hyvän elämän pääkaupungiksi
          </h2>
          <div>{list}</div>

          <h4 className="pageStart--description">
            Kuopion hyvinvointisuunnitelma linjaa toimintaa kuopiolaisten
            hyvinvoinnin ja terveyden edistämiseksi. Sen avulla ohjataan ja
            kehitetään hyvinvoinnin edistämistyötä koko Kuopiossa. Suunnitelman
            pohjana on viisi hyvinvoinnin osa-aluetta, niin sanottua hyvän
            elämän elementtiä, joiden alla on lukuisia tavoitteita ja
            toimenpidekokonaisuuksia.
            <br />
            <br />
            Kuopion hyvinvointisuunnitelmaan on sisällytetty myös seuraavat
            hyvinvoinnin edistämisen lakisääteiset suunnitelmat: lasten ja
            nuorten hyvinvointisuunnitelma, ikääntyneiden
            hyvinvointisuunnitelma, sekä ehkäisevän päihdetyön suunnitelma.
            Kuopion hyvinvointisuunnitelma pitää sisällään myös arjen
            turvallisuutta käsitteleviä osioita. Tällä sivustolla on esitetty
            hyvinvointisuunnitelman elementit, tavoitteet ja
            toimenpidekokonaisuudet. Tutustumalla koko suunnitelmaan, saat
            kattavan kuvan koko suunnitelmaa koskevista periaatteista,
            tahtotilasta ja tekemisestä kuopiolaisten hyvinvoinnin
            edistämiseksi.
          </h4>
        </div>
      </div>
    </div>
  );
};

export default PageHome;

const listItemProps = {
  textStyle: "plain",
  iconSize: "small",
  iconColor: "purple",
};

const list = (
  <>
    <ListItem {...listItemProps} index={5} text="Hyvän elämän elementtiä" />
    <ListItem {...listItemProps} index={14} text="Tavoitetta" />
    <ListItem {...listItemProps} index={28} text="Toimenpidekokonaisuutta" />
  </>
);
